import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'

import { DELIVERABLES_QUERY_KEY, getAllDeliverables } from '@/features/sessions/api'
import { DEFAULT_QUERY_STALE_TIME } from '@/lib/vue-query'

export default function useDeliverables(
  sessionIdRef: ComputedRef<string | null | undefined>,
  { keepQueryAlive }: { keepQueryAlive: boolean } = { keepQueryAlive: false },
) {
  const isGetDeliverablesQueryEnabled = computed(() => !!sessionIdRef.value)

  const { data, isPending } = useQuery({
    queryKey: [DELIVERABLES_QUERY_KEY, { sessionId: sessionIdRef }],
    queryFn: () => getAllDeliverables({ sessionId: sessionIdRef.value! }),
    enabled: isGetDeliverablesQueryEnabled,
    gcTime: 0, // we never want to use the cache for the deliverables
    staleTime: keepQueryAlive ? Infinity : DEFAULT_QUERY_STALE_TIME,
  })

  return {
    deliverablesRef: data,
    isPendingRef: isPending,
  }
}
